module.exports = __webpack_public_path__ + "img/6.7ae85ea1.gif";